import React, { memo } from 'react';
import { PROGRAM_ROUTE, TOREAD_ROUTE, CONTACT_ROUTE, HERO_SIZE, PREFIX, CHURCH, PLACE, SIGN_OUT_ROUTE, ACCOUNT_ROUTE, SERVICE_ROUTE } from 'config';
import { BrandBox, UserBox } from '@web/components';
import { AnimatedLogo } from 'components/AnimatedLogo';

export const PageNavigation = [
	{ link: PROGRAM_ROUTE, title: 'Program' },
	{ link: SERVICE_ROUTE, title: 'Služba' },
	{ link: TOREAD_ROUTE, title: 'Přečtěte' },
	{ link: CONTACT_ROUTE, title: 'Kontakt' },
];

export const PageLogo: React.FC<{ height: number }> = memo(({ height }) => (
	<BrandBox collapsed={HERO_SIZE < height - 100} prefix={PREFIX} church={CHURCH} place={PLACE}>
		<AnimatedLogo size={40}/>
	</BrandBox>
));

export const PageUser: React.FC = memo(() =>
	<UserBox signOutRoute={SIGN_OUT_ROUTE} accountRoute={ACCOUNT_ROUTE}/>
);
